import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import LiquidFillGauge from "react-liquid-gauge";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import DatagridComp from "../DatagridComp";
import { GetuserDatavalue } from "../../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import Commoncard from "../Commoncard";
import DomainAuthoritysvg from "../Asset/esocardicon/BaclinkResearch/DomainAuthority.svg"
import TotalBacklinkssvg from "../Asset/esocardicon/BaclinkResearch/TotalBacklinks.svg"
import TotalFollowlinkssvg from "../Asset/esocardicon/BaclinkResearch/TotalFollowlinks.svg"
import TotalReferringdomainssvg from "../Asset/esocardicon/BaclinkResearch/TotalReferringdomains.svg"
import Select from 'react-select';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { Container, Grid, Box, Card, CardContent, Typography, Avatar } from '@mui/material';
import BarChartIcon from "@mui/icons-material/BarChart";
import Stack from "@mui/material/Stack";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import PublicIcon from "@mui/icons-material/Public";
import { timezoneval } from './../Commonfun';

export default function CompetitorBacklinks(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [autoheightval, SetAutoheightval] = useState(true)
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const navigate = useNavigate();
  const [DomainAuthority, SetDomainAuthority] = useState(0)

  const [TotalBacklink, SetTotalBacklink] = useState(0)
  const [TotalReferringDomain, SetTotalReferringDomain] = useState(0)
  const [TotalFollowLink, SetTotalFollowLink] = useState(0)
  const [selectjobid, setselectjobid] = useState("");
  const [ResearchURL, SetResearchURL] = useState("");
  const [DomainURL, SetDomainURL] = useState("");
  const [selectCompError, setSelectCompError] = useState(null);
  const [competitorsValue, setCompetitorsValue] = useState(null);
  //  const [competitors, setCompetitors] = useState([]);
  const [summaryData, setSummaryData] = useState(null);

  const [competitors, setCardDatas] = useState([]);
  // const [competitorsID, setCardDatasID] = useState([]);




  const apihandleClose = () => {
    setapiOpen(false);
  };


  const columns = [

    {
      field: "referring_page",
      headerName: "Referring Page/Title",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: "Referring page's URL or referring page's title.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.referring_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.referring_page.split("/").slice(3).join("/");
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>{cardData?.row?.title}</span>
            <br />
            <Tooltip title={cardData.row.referring_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.referring_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },

    // {
    //   field: "da",
    //   headerName: "DA",
    //   minWidth: 80,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: false,
    //   description: "Domain InLink Rank of the target's root domain.",
    // },
    {
      field: "domain_authority",
      headerName: "DA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Domain InLink Rank of the target's root domain.",
      renderCell: (cardData) => {
        var sr = cardData.row.domain_authority;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    // {
    //   field: "pa",
    //   headerName: "PA",
    //   minWidth: 80,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: false,
    //   description: "InLink rank of the target URL.",
    // },
    {
      field: "page_authority",
      headerName: "PA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "InLink rank of the target URL.",
      renderCell: (cardData) => {
        var sr = cardData.row.page_authority;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: "#0b2033",
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
            }}
          />
        );
      },
    },
    {
      field: "anchor",
      headerName: "Anchor/Target Page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Link anchor text for text links/Destination page's URL.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.target_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.target_page.split("/").slice(3).join("/");
        let baseUrl1 = cardData?.row?.anchor?.split("/").slice(0, 3).join("/") || '' + "/";
        let remaining1 = cardData?.row?.anchor?.split("/").slice(3).join("/") || '';
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>
            {baseUrl1}<br />
            {remaining1}
          </span>
            <br />
            <Tooltip title={cardData.row.target_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.target_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "link_type",
      headerName: "Link Type",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'Type of backlink.',
    },
    {
      field: "nofollow",
      headerName: "Follow/No Follow",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'Number of backlinks marked as nofollow and number of backlinks not marked as nofollow.',
    },
    {
      field: "first_seen",
      headerName: "First Seen",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'The date when the backlink was added to the index or the date when our crawlers last visited the referring page.',
    },
    {
      field: "last_visited",
      headerName: "Last Visited",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "The date when the backlink was added to the index or the date when our crawlers last visited the referring page.",
    },

  ];

  const cardDatas = [
    { title: "Domain Authority", value: DomainAuthority, iconSrc: DomainAuthoritysvg, altText: "Domain Authority", iconColor: 1, bgColor: 1 },
    { title: "Total Backlinks", value: TotalBacklink, iconSrc: TotalBacklinkssvg, altText: "Total Backlinks", iconColor: 2, bgColor: 2 },
    { title: "Total Referring domains", value: TotalReferringDomain, iconSrc: TotalReferringdomainssvg, altText: "Total Referring domains", iconColor: 3, bgColor: 3 },
    { title: "Total Follow links", value: TotalFollowLink, iconSrc: TotalFollowlinkssvg, altText: "Total Follow links", iconColor: 4, bgColor: 4 },
  ];

  const rows = cardData ?? [];





  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);
    props.setCardDatas([]);

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_competitor_domains/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      let competitorsRaw = res?.data?.table?.competitors || [];
      competitorsRaw = [{
        id: '',
        competitor_name: 'Select a Competitor',
        isDisabled: true
      }].concat(competitorsRaw);

      const transformedCompetitors = competitorsRaw.map((item, index) => ({
        ...item,
        sid: index + 1,
        label: item.competitor_name,
        value: item.id,
      }));

      if (transformedCompetitors.length > 0) {
        props.setCardDatas(transformedCompetitors);
        // console.log("id", transformedCompetitors)
        // console.log("IDs only:", transformedCompetitors.map(item => item.id));
        // props.setCardDatasID(transformedCompetitors);
        SetAutoheightval(false);
      } else {
        props.setCardDatas([]);
        SetAutoheightval(true);
      }

    } catch (error) {
      if (error?.response?.status === 599 || error?.response?.status === 400 || error?.response?.status === 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error);
        if (props.competitors.length > 0) {
          LoadDataTable();
        }
      } else if (error?.code === "ERR_NETWORK" || error?.response?.status === 404) {
        navigate('/errorpages');
      }
      // setCardDatas([]);

      SetAutoheightval(true);
    }

    setLoading(false);
    setTableLoading(false);
  };



  const onSelectCompetitor = (selected) => {
    setCompetitorsValue(selected);
  };

  const LoadDataTable = async (id) => {


    setLoading(true);
    setTableLoading(true);

    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}backlinks/competitor_backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}&competitor_id=${id}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (
            error?.code == "ERR_NETWORK" ||
            error?.response?.status == 404
          ) {
            navigate("/errorpages");
          }
        });

      props.setCardDatasID(id)

      if (datavalue?.data) {
        SetDomainURL(datavalue.data.domain_url)
        const summary = datavalue.data.research_summary;
        if (summary) {
          SetDomainAuthority(summary.domain_authority);
          SetTotalBacklink(summary.total_backlinks_count);
          SetTotalReferringDomain(summary.total_ref_domains)
          SetTotalFollowLink(summary.total_follow_links)
          SetResearchURL(summary.research_url)
        }
        if (datavalue?.data?.research_table) {
          const TableArray = datavalue.data.research_table.data;
          if (TableArray && TableArray.length > 0) {
            const newData = TableArray.map((obj, index) => ({
              ...obj,
              sid: index + 1,
            }));
            setCardData(newData);
            SetAutoheightval(false);
          } else {
            setCardData("");
            SetAutoheightval(true);
          }
        }
      }
    } catch (err) {
      console.log(err);
    }

    setTableLoading(false);
    setLoading(false);
  };

  useEffect(() => {
    if (props.competitors.length > 0) {
      const defaultComp = props.competitors[1]; // or any logic for default
      if (!props.competitorsValue) {
        props.setCompetitorsValue(defaultComp);
        LoadDataTable(defaultComp.value);
      } else {
        LoadDataTable(props.competitorsValue.value);
      }
    }
  }, [props.competitors, props.competitorsValue]);



  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    // LoadData()
    // LoadDataTable()
    callUserdataApi()
  }, []);

  useEffect(() => {
    if (props.FilterButtonTriggered === true) {
      // LoadData()
      LoadDataTable()
      props.SetFilterButtonTriggered(false)
      props.closeModal()
    }

  }, [props])

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const handleModelPopUp = () => {
    props.openModal();
  }

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  // const cardDatas = [
  //   {
  //     title: "Domain Authority",
  //     value: DomainAuthority,
  //     altText: "Domain Authority",
  //     icon: <BarChartIcon />,
  //     iconColor: "#fff",
  //     bgColor: "#786dfb",
  //   },
  //   {
  //     title: "Total Backlinks",
  //     value: TotalBacklink,
  //     altText: "Total Backlinks",
  //     icon: <LinkIcon />, // changed from EqualizerIcon to LinkIcon
  //     iconColor: "#fff",
  //     bgColor: "#fd5c63",
  //   },
  //   {
  //     title: "Total Referring domains",
  //     value: TotalReferringDomain,
  //     altText: "Total Referring domains",
  //     icon: <PublicIcon />, // changed from TrendingUpIcon to PublicIcon
  //     iconColor: "#fff",
  //     bgColor: "#20e2b2",
  //   },
  //   {
  //     title: "Total Follow links",
  //     value: TotalFollowLink,
  //     altText: "Total Follow links",
  //     icon: <LinkIcon />,
  //     iconColor: "#fff",
  //     bgColor: "#ff6600",
  //   },

  // ];


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Competitor Backlinks</title>
      </Helmet>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Container maxWidth={false} className="graph-container">
        <Box className="graph-box">
          <Grid container className="graph-grid">
            <Grid item xs={12} md={12}>
              <div style={{ textAlign: "center" }}>
                {DomainURL && (
                  <p className="run_report_footer" style={{ color: "#000", textAlign: "center", display: "inline-block", borderRadius: "99rem", padding: "10px 18px", backgroundColor: "#fff !important" }}>
                    Competitor backlinks research for <b style={{ color: "#3571ff" }}>{DomainURL}</b> vs <b style={{ color: "#3571ff" }}>{ResearchURL}</b>
                  </p>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "20px", marginBottom: "0px" }} >
        <Box style={{ padding: "0px 20px 0px 20px" }}>
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={12}>
              <div className="common-card-container">
                {cardDatas.map(({ title, value, iconSrc, altText }) => (
                  <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
                ))}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid container spacing={3} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Commoncard item={item} />
                  {/* <Card className="dashboard_card"
                    sx={{
                      borderRadius: "15px",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                      // borderLeft:"3px solid #ff601f",
                      borderLeft: `3px solid ${item.bgColor}`,
                      transition: "0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 12px 40px rgba(0,0,0,0.08)",
                      },
                    }}
                  >
                    <CardContent sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Avatar
                        sx={{
                          bgcolor: item.bgColor,
                          color: item.iconColor,
                          width: 50,
                          height: 50,
                        }}
                      >
                        {item.icon}
                      </Avatar>
                      <Stack>
                        <h5 variant="subtitle1" sx={{ fontWeight: 600 }}>
                          {item.title}
                        </h5>
                        <h4 variant="h5" sx={{ fontWeight: "bold", color: "#2d2f3e" }}>
                          {item.value}
                        </h4>
                      </Stack>
                    </CardContent>
                  </Card> */}
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "40px", marginBottom: "30px" }}>
      <Grid container spacing={3}>
        <Box sx={{ flexGrow: 1, padding: "20px" }} style={{ padding: "0px 20px 0px 20px" }}>
      
    </Box>
      </Grid>
    </Container> */}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 400]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      {/* 
      <DatagridComp
        columns={columns}
        rows={rows}
        autoheightval={autoheightval}
        datagridval={2}
        columnFreezeWidth={[0, 400]}
        tableLoading={tableLoading}
      /> */}



      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }
    </>
  );
}
